import React, { FunctionComponent, useState, useEffect, useRef } from 'react';
import {  Modal, Button, Container, Row, Col, Form, Alert, Spinner } from 'react-bootstrap';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faPaypal } from '@fortawesome/free-brands-svg-icons';
import SessionService from '../../services/SessionsService';


type editTeamProps = {
  show: boolean,
  organization: Number,
  organization_name: string,
  organization_description: string,
  handleClose: () => void
}
const EditOrganizationModal:FunctionComponent<editTeamProps> = (props) => {

  const [cardNumber, setCardNumber] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [cvv, setCVV] = useState('');
  const [cardholder, setCardholder] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitDisabled, setSubmitDisabled] = useState(true);


  const yearInputRef = useRef(null);
  const cvvInputRef = useRef(null);

  const changeCardNumber = (e) => {
    var newCardNumber = e.target.value; // remove hyphens
    setCardNumber(newCardNumber);
    if (newCardNumber.length>3 && cardholder.length>3 || (props.organization_description.length>3 && props.organization_name.length>3)) setSubmitDisabled(false);
  }

  const changeMonth = (e) => {
    const newMonth = e.target.value;
    setMonth(newMonth);
    if (newMonth.toString().length == e.target.maxLength){
      yearInputRef.current.focus();
    }
  }

  const changeYear = (e) => {
    const newYear = e.target.value;
    setYear(newYear);
    if (newYear.toString().length == e.target.maxLength){
      cvvInputRef.current.focus();
    }
  }

  const changeCardholder = (e) => {
    const newCardholder = e.target.value;
    setCardholder(newCardholder);

    if (newCardholder.length>3 && cardNumber.length>3 || (props.organization_description.length>3 && props.organization_name.length>3)) setSubmitDisabled(false);
    

  }

  const changeCVV = (e) => {
    const newCVV = e.target.value;
    setCVV(newCVV);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setLoading(true);
    setError('');// Limpiamos los posibles errores


    const payload = { "organization": props.organization, "description": (cardNumber || props.organization_description), "name": (cardholder || props.organization_name)};
    console.log(payload);
    const result = await ObexRequestHandler.post('/organizations', payload);

    //const result = await ObexRequestHandler.post(`/organizations` , {}, true );
    const { success, data, message } = result;
    if (success){
      setLoading(false);
      setSuccess(data);
        setTimeout(function() { 
          setSuccess('');
          setSubmitDisabled(true);
          props.handleClose();
          }.bind(this), 1000)
    } else {
      setError(message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cardNumber && month && year && cvv && cardholder){
      setSubmitDisabled(false);
    }
  })
  return(
    <Modal dialogClassName="addons-dialog obex-dialog"
      show={props.show} 
      onHide={props.handleClose}
      animation={false}
      scrollable>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="text-center mx-auto">
          <Col md="12" className="addons-title">
            <span>Edit <b>organization {props.organization_name}</b></span>
          </Col>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md="10" className="mx-auto">
            <Form className="obex-form payment-method-form" onSubmit={handleSubmit}>
              {/* <Form.Row className="py-2">
                <Form.Label column sm="12" className="obex-form-label">
                  How would you like to pay?
                </Form.Label>
                <Col md="1" className="text-right py-1 pr-5">
                  <Form.Check
                    type="radio"
                    value="CreditCard"
                    name="formHorizontalRadios"
                    id="formHorizontalRadios1"
                  />
                </Col>
                <Col className="type-payment-method py-1 pl-3">
                  <span><FontAwesomeIcon icon={faCreditCard}/> Credit Card</span>
                </Col>
              </Form.Row>
              <Form.Row className="py-2 mb-3">
                <Col md="1" className="text-right py-1 pr-5">
                  <Form.Check
                    type="radio"
                    value="PayPal"
                    name="formHorizontalRadios"
                    id="formHorizontalRadios2"
                  />
                </Col>
                <Col className="type-payment-method py-1 pl-3">
                  <span><FontAwesomeIcon icon={faPaypal}/> Paypal</span>
                </Col>
              </Form.Row> */}
              <Form.Row className="mb-3">
                <Form.Label column sm="12" className="obex-form-label">
                  Organization Name*
                </Form.Label>
                <Form.Control required type="text" placeholder="Name" value={cardholder || props.organization_name} onChange={changeCardholder}/>
              </Form.Row>
              <Form.Row className="mb-3">
                <Form.Label column sm="12" className="obex-form-label">
                  Organization Description*
                </Form.Label>
                <Col md="12">
                  <Form.Control required type="text" maxLength={40} value={cardNumber || props.organization_description} placeholder="Description" onChange={changeCardNumber}/>
                </Col>
              </Form.Row>

              
              <Form.Row className="my-3">
                <Col md="4" className="ml-auto">
                  <Button disabled={submitDisabled} type="submit" className="btn-block obex-btn btn-green">
                      Update {success && <FontAwesomeIcon icon={faCheck}/>}
                    {loading && <Spinner animation="border" size="sm" style={{ marginLeft: '8px' }}/>}
                  </Button>
                </Col>
              </Form.Row>
            </Form>
            {error && <Alert variant="danger">
              {error}
            </Alert>}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default EditOrganizationModal;